export var TenantBillingStatus;
(function (TenantBillingStatus) {
    /** Typically a new or dormant tenant. */
    TenantBillingStatus[TenantBillingStatus["Unbillable"] = 0] = "Unbillable";
    /** When invoices are generated payment is processed automatically. */
    TenantBillingStatus[TenantBillingStatus["AutoPay"] = 1] = "AutoPay";
    /** This tenant is not required to pay us for service. */
    TenantBillingStatus[TenantBillingStatus["Free"] = 2] = "Free";
    /** We bill this tenant manually. */
    TenantBillingStatus[TenantBillingStatus["ManualPay"] = 3] = "ManualPay";
})(TenantBillingStatus || (TenantBillingStatus = {}));
